<template>
  <div
    class="job-card"
    :class="status.toLowerCase().trim().replace(/ /g,'-')"
    @click="showJobDetail(jobId)"
  >
    <div class="inner">
      <span class="urgent-flag" v-if="priority.toLowerCase().trim() == 'urgent'">
        <font-awesome-icon icon="flag" fixedWidth class="icon"/>Urgent
      </span>
      <b-row class="mb-2">
        <b-col>
          <h4 class="mb-0">{{ labRef }}</h4>
        </b-col>
        <b-col>
          <div class="job-purchase-order text-right">{{ clientRef }}</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="job-samples text-left">
            {{ sampleCount }}
            <span v-if="sampleCount <= 1">Sample</span>
            <span v-if="sampleCount > 1">Samples</span>
          </div>
        </b-col>
        <b-col>
          <div class="job-dates text-right">{{ receivedDate | moment("D MMM YYYY") }}</div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";

.job-card {
  position: relative;
  border: 1px solid $ui-gray-light;
  border-radius: 3px;
  overflow: hidden;
  transition: all 200ms;

  &:before {
    content: "";
    width: 100%;
    height: 3px;
    position: absolute;
    left: 0;
    top: 0;
  }

  &.registered {
    border-color: rgba($status-processing, 0.2);
    &:before {
      background: $status-processing;
    }
  }

  &.complete {
    border-color: rgba($status-completed, 0.2);
    &:before {
      background: $status-completed;
    }
  }

  &.results-available {
    border-color: rgba($status-finalised, 0.2);
    &:before {
      background: $status-finalised;
    }
  }

  .inner {
    padding: 1rem;
    h4 {
      font-size: 1.3rem;
      font-weight: $font-weight-semibold;
    }

    .urgent-flag {
      font-size: 0.9rem;
      color: $danger;
      .icon {
        margin-right: 5px;
        font-size: 0.9rem;
      }
    }

    .job-description,
    .job-purchase-order {
      color: $text-color-light;
    }

    .job-samples,
    .job-dates {
      font-size: 0.8rem;
      font-weight: $font-weight-semibold;
    }
  }

  .view-job {
    background: $ui-gray-lightest;
    padding: 0.5rem 0;
    text-align: center;
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: $font-weight-semibold;
    .icon {
      margin-left: 10px;
      transition: all 200ms;
    }
  }

  &:hover {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    .view-job {
      color: $brand-primary;
      .icon {
        transform: translateX(5px);
      }
    }
  }
}
.job-card + .job-card {
  margin-top: 15px;
}
</style>

<script>
export default {
  name: "JobCard",
  components: {},
  props: {
    status: String,
    labRef: String,
    jobId: String,
    description: String,
    clientRef: String,
    purchaseOrder: String,
    sampleCount: Number,
    receivedDate: String,
    dueDate: String,
    priority: String
  },
  methods: {
    showJobDetail: function(jobId) {
      this.$router.push({ path: `/jobs/${jobId}` });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/JobCard.vue